var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vb-modal',{ref:_vm.ref_id,attrs:{"vb_options":{
    id: _vm.ref_id,
    size: 'lg',
    title: 'Dettaglio del viaggio',
    hide_footer: true, 
  }}},[_c('div',{staticClass:"flight-pad-details-modal"},[_c('main',{staticClass:"flight-pad-details-modal__main"},[_c('flight-pad-details',{attrs:{"flight_offer":_vm.flight_offer,"show_dates":""}})],1),(_vm.selectable)?_c('footer',{staticClass:"flight-pad-details-modal__footer"},[_c('div'),_c('flight-pad-price-button',{attrs:{"flight_offer":_vm.flight_offer,"direction":"horizontal"}})],1):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }